import { render, staticRenderFns } from "./exercise-tile.component.vue?vue&type=template&id=40dac5e4"
import script from "./exercise-tile.component.ts?vue&type=script&lang=ts&external"
export * from "./exercise-tile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./exercise-tile.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports